import { ReactNode, useEffect, useState } from 'react';

import { Navigate } from 'react-router-dom';

import type { PageViewSourceState } from '@/shared/lib/pageViewSource';

import {
  RECORDING_ANNOUNCEMENT_REDIRECT_STATE,
  useRecordingAnnouncementRedirect,
} from '@/features/recordingAnnouncement';

import { useProductShell } from '@/entities/user/trialVariant';

import { PATHS } from '@/shared/constants/routes/paths';
import { Loader } from '@/shared/ui/Loader';

const DEFAULT_TAB_SOURCE_STATE: PageViewSourceState = { source: 'default_tab' };

type SpaceIndexRouteProps = {
  children: ReactNode;
};

type Landing = {
  showAnnouncement: boolean;
  startOnTranslation: boolean;
};

export const SpaceIndexRoute = ({ children }: SpaceIndexRouteProps) => {
  const { markStartScreenShown, startOnTranslation, status } = useProductShell();
  const announcement = useRecordingAnnouncementRedirect();
  const { markRedirected: markAnnouncementRedirected } = announcement;
  const [landing, setLanding] = useState<Landing | null>(null);

  if (status === 'resolved' && announcement.status === 'resolved' && landing === null) {
    setLanding({ showAnnouncement: announcement.shouldRedirect, startOnTranslation });
  }

  useEffect(() => {
    if (landing?.startOnTranslation) markStartScreenShown();
  }, [landing, markStartScreenShown]);

  useEffect(() => {
    if (landing?.showAnnouncement) markAnnouncementRedirected();
  }, [landing, markAnnouncementRedirected]);

  if (landing === null) return <Loader />;

  if (landing.showAnnouncement) {
    return <Navigate state={RECORDING_ANNOUNCEMENT_REDIRECT_STATE} to={PATHS.translation} replace />;
  }

  if (landing.startOnTranslation) return <Navigate state={DEFAULT_TAB_SOURCE_STATE} to={PATHS.translation} replace />;

  return children;
};
